import { styled as t, Box as i } from "@mui/material";
import n from "../../temp-lib/components/share/next/Image.js";
import a from "../assets/image-divider.svg.js";
import c from "../assets/image-divider-center.svg.js";
import { jsx as e } from "react/jsx-runtime";
const s = t(i)`
  align-items: center;
  background-image: url(${`"${a}"`});
  background-position: center;
  background-repeat: no-repeat;
  background-size: 1239px 38px;
  display: flex;
  height: 1px;
  justify-content: center;
  width: 100%;
`, p = t(n)`
  aspect-ratio: 1;
  width: 50px;
  z-index: 1; // force z-index to show
`, l = (r) => {
  const {
    className: o
  } = r;
  return /* @__PURE__ */ e(s, {
    className: o,
    children: /* @__PURE__ */ e(p, {
      src: c
    })
  });
};
export {
  l as default
};
//# sourceMappingURL=ApeironDivider.js.map
